import { gql } from '../../../../__generated__/gql';

export const PEOPLE_FOR_LINK_QUERY = gql(/* GraphQL */`
    query PeopleForLink {
        persons {
            ...PeopleForLink__Person
        }
    }
`);
